import React, { useEffect, useState } from "react";

import Footer from "../Footer/Footer";
import { PostsAPI } from '../../lib/API';
import { STATIC_URL } from '../../Env'
import moment from 'moment';

import logo from '../../assets/logo.svg'
import { AuthorRow } from "./AuthorRow";

const Blog = () => {

  const defaultCols = [4, 4, 4, 6, 6];

  const [posts, setPosts] = useState({
    items: null,
    count: 0
  });
  const [page, setPage] = useState(1);

  useEffect(() => {
    PostsAPI.GetPosts(page)
      .then(({ data }) => setPosts(data))
      .catch(() => alert("An error occured"));
  }, [page])

  if (!posts.items) return <></>

  if (posts.items && posts.items.length == 0)
    return (
      <>
        <div className="page-head text-center">
          <div className="col-lg-2">
            <div className="mybasket">
              <h3>Blog Posts</h3>
              <p>Follow on what we up to. </p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col" style={{ padding: "100px 50px" }}>
              <h2 className="text-center">Keep in touch to be updated <br /> with our latest news</h2>
            </div>
          </div>
        </div>
      </>
    )

  return (
    <>

      <div className="page-head text-center">
        <div className="col-lg-2">
          <div className="mybasket">
            <h3>Blog Posts</h3>
            <p>Follow on what we up to. </p>
          </div>
        </div>
      </div>

      <div className="blog-archive pb-5">
        <div className="news-section container">
          <div className="row">
            <div className="col-lg-6">
              <img src={`${STATIC_URL}${posts.items[0].picture}`} alt="polisnews" />
            </div>
            <div className="col-lg-6">
              <div className="featured-news">
                <h4>{posts.items[0].title}</h4>
                <p>{posts.items[0].content}</p>
                <AuthorRow author={posts.items[0].author} author_pic={posts.items[0].author_pic} post={posts.items[0]}/>
              </div>
            </div >
            {posts.items.slice(1).map((p, i) => (
              <ColPost post={p} cols={defaultCols[i % 5]} />
            ))
            }
          </div>
        </div>
      </div>
    </>
  );
};

const ColPost = ({ post, cols }) => {
  const contentSlim = post.content.substring(0, 130) + (post.content.length > 130 ? "..." : '')

  return (
    <div className={`col-lg-${cols} mt-5 post-item`}>
      <div className="post-image">
        <img src={`${STATIC_URL}${post.picture}`} />
      </div>
      <div className="featured-news">
        <h4>{post.title}</h4>
        <p className="post-content">{contentSlim}</p>
        <AuthorRow author={post.author} author_pic={post.author_pic} post={post}/>
      </div>
    </div>
  )
}
export default Blog;
